import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import MasterLogistikTable from "../common/masterLogistikTable";
import {formGroupVarian, tableConfig} from "../config";
import MasterLogistikMotorVarianModifying from "./modal/MasterLogistikMotorVarianModifying";
import Api from "../../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import MasterLogistikMotorVarianFilter from "./modal/MasterLogistikMotorVarianFilter";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../../modules/popup/SimplePrintTable";
import {checkAndHandleError, convertFileToBase64, fetchDataAsync} from "../../../../Services/Utils";
import {HttpStatus} from "../../../common/Constants";
import SimpleUploadExcel from "../../../../modules/upload/SimpleUploadExcel";
import {saveAs} from 'file-saver'

class MasterLogistikMotorVarian extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = tableConfig.varian;
        this.initialData = {
            kodeVariant: null,
            kodeUnitPabrik: null,
            namaVariant: null,
            isiSilinder: null,
            digitAwalNosin: null,
            digitAwalNoka: null,
            idType: null,
            discontinue: null,
        };
        this.initialSearch = {
            namaVariant: null,
        };
        this.state = {
            filterModalVisible: false,
            modifyingVisible: false,
            printModalVisible: false,
            uploadModalVisible: false,
            file: null,
            selectedData: null,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
            dataTypeDDL: [],
            dataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataVariant();
        this.handleTriggerLoading();
    }

    handleModifyingModalVisibility = async (index) => {
        this.handleTriggerLoading();
        if (!this.state.modifyingVisible) {
            await this.fetchDataType();
        }

        if (!R.isNil(index)) {
            let res = await this.callApi(
                Api.create("NAGAMAS_MASTER_DATA").getVariantById,
                this.state.dataTable[index].kodeVariant,
            );
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        idType: mapToObjectDDL(
                            res.data.data.typeDTO.typeName,
                            res.data.data.typeDTO.id
                        ),
                        discontinue: mapToObjectDDL(
                            res.data.data.discontinue ? "YES" : "NO",
                            res.data.data.discontinue
                        ),
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }

        this.handleTriggerLoading();
    };

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleUploadModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            uploadModalVisible: !prevValue.uploadModalVisible
        }));
    }

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const requestBody = {
            ...formGroup,
            idType: getValueFromDDL(formGroup, "idType"),
            discontinue: getValueFromDDL(formGroup, "discontinue"),
        };
        let api;
        if (!R.isNil(this.state.selectedData)) {
            api = Api.create("NAGAMAS_MASTER_DATA").updateVariant;
        } else {
            api = Api.create("NAGAMAS_MASTER_DATA").saveVariant;
        }
        let res = await this.callApi(
            api,
            requestBody,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            this.handleModifyingModalVisibility();
            await this.fetchDataVariant({
                paramFilters: this.state.submittedFilterData,
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        let req = {
            paramFilters: removeNullFields(this.parseFilterData(this.state.filterData)),
            limit: 5,
            page: 1
        };
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.fetchDataVariant(req);
        this.handleClearSearch();
        await this.handleModalFilterVisibility();
        this.handleTriggerLoading();
    };

    handleChangeStatus = async (index, value) => {
        this.handleTriggerLoading();
        let data = this.state.dataTable[index];
        data.status = value ? "ACTIVE" : "INACTIVE";
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").updateStatusVariant,
            {kodeVariant: data.kodeVariant, status: data.status}
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            await this.fetchDataVariant({
                paramFilters: this.state.submittedFilterData,
                page: this.state.pagination.page,
                limit: this.state.pagination.limit,
            });
        }
        this.handleTriggerLoading();
    };

    handleSearch = async () => {
        this.handleTriggerLoading();
        this.handleClearForm();
        let req = {
            paramFilters: removeNullFields(this.state.search),
            limit: 5,
            page: 1,
        }
        this.handleChangeSubmittedFilterData(req.paramFilters);
        await this.fetchDataVariant(req);
        this.handleTriggerLoading();
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: name === 'isiSilinder' ? Number(value) : value,
            },
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleFileChange = async (e) => {
        const file = e.target.files[0];
        try {
            const base64File = await convertFileToBase64(file);
            this.setState((prevState) => ({
                ...prevState,
                file: base64File,
            }));
        } catch (error) {
            console.error("Error converting file to Base64:", error);
        }
    };

    handleClearForm = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: this.initialData,
        }));
    };

    handleClearSearch = () => {
        this.setState((prevValue) => ({...prevValue, search: this.initialSearch}));
    };

    handleUpload = async (file) => {
        try {
            this.handleTriggerLoading();
            const renamedFile = new File([file], "VARIANT.xlsx", {
                type: file.type,
            });

            const formData = new FormData();
            formData.append("file", renamedFile);

            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadExcelVariant(formData);
            if (res.ok) {
                if (res.data.status === HttpStatus.FAILED && res.data.code === 503) {
                    this.handleTriggerLoading();
                    return checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Varian");
                }
                if (res.data.status === HttpStatus.SUCCESS) {
                    this.handleTriggerLoading();
                    return true;
                }
            }
        } catch (e) {
            console.log("error: ", e);
        }
        this.handleTriggerLoading();
        return false;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataVariant({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (page, limit, callback) => {
        this.handleTriggerLoading();
        this.setState(callback);
        let {submittedFilterData} = this.state;
        await this.fetchDataVariant({
            paramFilters: submittedFilterData,
            page: page,
            limit: limit
        });
        this.handleTriggerLoading();
    }

    fetchDataVariant = async (body) => {
        this.setState((prevState) => ({...prevState, pagination: {...prevState.pagination, count: 0}}));
        let req = body && Object.keys(body).length > 0
            ? body :
            {
                paramFilters: {},
                page: 1,
                limit: 5,
            };
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllVariantPaging,
            req,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    count: res.data.totalData,
                    page: req.page,
                    limit: req.limit,
                }
            }));
        }
    };

    fetchDataType = async () => {
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllType,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTypeDDL: res.data.data.map(item => mapToObjectDDL(item.typeName, item.id)),
            }));
        }
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeVariant: getValueFromDDL(data, "kodeVariant"),
            discontinue: getValueFromDDL(data, "discontinue"),
        };
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Logistik Motor - Varian",
            setError: this.props.setError,
            args: args,
        })
    };

    handleChangeSubmittedFilterData = (data) => {
        this.setState((prevState) => ({
            ...prevState,
            submittedFilterData: data,
        }));
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: this.initialData,
            search: this.initialSearch,
            submittedFilterData: {},
        }));
    };

    handleDownloadTemplate = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadTemplateVariant();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Varian")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "TEMPLATE_UPLOAD_VARIANT.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            console.log("error: ", err);
        }
    };

    handleDownloadLogError = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadErrorLogVariant();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Logistik Motor - Varian")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "PART_LOG.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    };

    handlePrint = async () => {
      const { setError } = this.props;
      this.handleTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE")
          .downloadVariantSegmenExcel,
        setError: setError,
        menuName: "Master Logistik Motor - Varian",
      });
      this.handleTriggerLoading();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Master_Logistik_Motor_Varian_.xlsx");
      }
    };

    render() {
        return (
            <>
                <FlexView
                    style={{justifyContent: "space-between"}}
                    className="margin-bottom-5px margin-top-5px"
                >
                    <FlexView vAlignContent="center" className="margin-bottom-5px">
                        <SimpleInput
                            type="text"
                            name="namaVariant"
                            onChange={(e) => this.handleValueChange(e.target.name, e.target.value)}
                            value={this.state.search.namaVariant}
                            placeholder="Nama Varian"
                            containerclassname="margin-bottom-none"
                        />
                        <SimpleButton onClick={this.handleSearch} className="margin-top-5px">Cari</SimpleButton>
                    </FlexView>
                    <Button
                        type="button"
                        className="margin-top-5px btn background-red"
                        onClick={this.handleModalFilterVisibility}
                    >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </FlexView>
                <MasterLogistikTable
                    tableConfig={this.tableConfig}
                    menuAccess={this.props.menuAccess}
                    data={this.state.dataTable}
                    onEdit={this.handleModifyingModalVisibility}
                    onChangeStatus={this.handleChangeStatus}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    pagination={this.state.pagination}
                    additionalButtons={
                        <FlexView vAlignContent="center">
                            {
                                this.props.menuAccess && this.props.menuAccess.createAccess && (
                                    <SimpleButton
                                        onClick={() => this.handleModifyingModalVisibility()}
                                        icon={<i className="fa fa-plus margin-right-10px"></i>}
                                        text={"Tambah"}
                                    />
                                )
                            }
                            <SimpleButton
                                text="Cetak"
                                onClick={() => this.handlePrint()}
                            />
                            <SimpleButton
                                text="Upload"
                                onClick={() => this.handleUploadModalVisibility()}
                            />
                        </FlexView>
                    }
                />

                {this.state.modifyingVisible && (
                    <MasterLogistikMotorVarianModifying
                        formGroup={formGroupVarian}
                        initialValues={this.state.selectedData}
                        selectedData={this.state.selectedData}
                        dataTypeDDL={this.state.dataTypeDDL}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={this.handleModifyingModalVisibility}
                    />
                )}

                {this.state.filterModalVisible && (
                    <MasterLogistikMotorVarianFilter
                        selectedData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        onSubmit={this.handleSubmitFilter}
                        onValueChange={this.handleValueChange}
                        onClearForm={this.handleClearForm}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                {this.state.uploadModalVisible && (
                    <SimpleUploadExcel
                        downloadError={true}
                        visible={this.state.uploadModalVisible}
                        onDownloadTemplate={this.handleDownloadTemplate}
                        onDownloadLogError={this.handleDownloadLogError}
                        onChange={this.handleUpload}
                        onClickClose={this.handleUploadModalVisibility}
                    />
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikMotorVarian;